import { useState, useRef } from "react";
import toast from "react-hot-toast";
import JajotApi from "../api/JajotApi";

export function useTallySync(onCompleted) {
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncStatus, setSyncStatus] = useState("new"); // new/completed/error/retry
  const intervalRef = useRef(null);

  const stopSync = () => {
    console.log("[TallySync] Stopped");
    clearInterval(intervalRef.current);
    setIsSyncing(false);
    setSyncStatus("new");
  };

  const startSync = async (remoteFunction) => {
    try {
      console.log("[TallySync] Start:", remoteFunction);
      setIsSyncing(true);
      setSyncStatus("new");

      const payload = { Status__c: "New", Remote_Function__c: remoteFunction };
      const res = await JajotApi.createTallyRequest(payload);
      console.log("[TallySync] API response:", res);

      if (
        res?.success ||
        res?.message?.toLowerCase().includes("request already in progress")
      ) {
        pollStatus(res.id, remoteFunction);
      } else {
        toast.error(res?.message || "Failed to start sync");
        stopSync();
      }
    } catch (err) {
      console.error("[TallySync] Start error:", err);
      toast.error("Failed to start sync");
      stopSync();
    }
  };

  const pollStatus = (requestId, remoteFunction) => {
    const POLL_INTERVAL = 10000;
    const TIMEOUT = 120000;
    let elapsed = 0;

    intervalRef.current = setInterval(async () => {
      elapsed += POLL_INTERVAL;

      try {
        const statusRes = await JajotApi.getTallyRequestStatus(requestId);
        const status = statusRes?.record?.message?.toLowerCase() || "";
        console.log(`[TallySync] Status: ${status}`);
        setSyncStatus(status);

        if (status === "completed") {
          clearInterval(intervalRef.current);
          toast.success(`${remoteFunction} sync completed`);
          if (onCompleted) onCompleted();
        } else if (status === "error") {
          clearInterval(intervalRef.current);
          toast.error(`${remoteFunction} sync failed`);
        }
      } catch (err) {
        console.error("[TallySync] Poll error:", err);
      }

      if (elapsed >= TIMEOUT) {
        clearInterval(intervalRef.current);
        setSyncStatus("error");
        toast.error(`${remoteFunction} sync timed out`);
      }
    }, POLL_INTERVAL);
  };

  return { isSyncing, syncStatus, startSync, stopSync };
}
